/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * Button styled components
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { IAttrStyled, TButtonKind } from '@/main/types/globalTypes';
import { button } from '@theme/index';

export interface IStyledProps extends IAttrStyled {
    kind: TButtonKind;
    height?: string;
}

export const ButtonStyled = styled.button.attrs(({ className }: IAttrStyled) => ({
    className: `button__button-content ${className || ''}`,
    tabIndex: 0,
}))<IStyledProps>`
    min-height: ${(props) => (props.height ? props.height : button.height)};
    padding: 0 ${button.padding};
    border: ${button.border};
    border-radius: 100px;
    background-color: ${button.bgColor};
    cursor: pointer;
    outline: none;
    text-align: center;
    ${button.font};
    color: ${button.color};
    line-height: 1;

    :focus,
    :hover {
        background-color: ${button.bgColorHover};
        color: ${button.colorHover};
        border: ${button.borderHover};
    }

    &.disabled,
    :disabled {
        background-color: ${button.bgColorDisabled};
        color: ${button.colorDisabled};
        border: ${button.borderDisabled};
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
    }

    :active {
        background-color: ${button.bgColorDown};
        color: ${button.colorDown};
        border: ${button.borderDown};
        outline: none;
    }

    &.disabled:active,
    :active:disabled {
        background-color: ${button.bgColorDownDisabled};
        color: ${button.colorDownDisabled};
        border: ${button.borderDownDisabled};
    }
`;

export const ButtonContainerStyled = styled.span`
    display: inline-flex;
`;

export const ButtonImageStyled = styled.img.attrs(({ className }: IAttrStyled) => ({
    className: `button__img-content ${className || ''}`,
}))<IAttrStyled>`
    display: block;
`;
